import styled from 'styled-components';

import {SubscriptionStatusEnum} from '@/entities/subscriptions/types';
import {colors, font} from '@app/styles/theme';

export const Wrapper = styled.div<{noBg?: boolean}>`
    margin-right: auto;
    flex: 1;
    height: 90%;
    align-self: flex-start;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    background-color: ${(p) => (p.noBg ? 'transparent' : colors.brandLight)};
    overflow: hidden;
`;

export const Container = styled.div`
    box-sizing: border-box;
    padding: 16px;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 16px;
`;

export const Name = styled.div`
    color: ${colors.brandPrimary};
    font-family: ${font.family.primary};
    font-size: 28px;
    font-weight: 600;
    line-height: 34px;
`;

export const Pill = styled.div<{$status?: SubscriptionStatusEnum}>`
    align-self: flex-start;
    background-color: ${colors.brandPrimary};
    color: ${colors.white};
    padding: 4px 16px;
    border-radius: 16px;
    font-family: ${font.family.primary};
    font-size: 16px;
    font-weight: 600;
    background: ${(p) => {
        switch (p.$status) {
            case SubscriptionStatusEnum.ACTIVE:
                return colors.success;
            case SubscriptionStatusEnum.CANCELLED:
                return colors.danger;
            case SubscriptionStatusEnum.PAYMENT_PENDING:
                return colors.warningSecondary;
            default:
                return colors.brandPrimary;
        }
    }};
`;
export const BannerText = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;

    @media (max-width: 1150px) {
        display: none;
    }
`;

export const BannerTitle = styled.h3`
    font-family: ${font.family.primary};
    padding: 0;
    margin: 0;
    font-size: 16px;
    font-weight: 600;
    line-height: 20px;
    color: ${colors.textGrey1};
`;

export const BannerDescription = styled.p`
    font-family: ${font.family.primary};
    padding: 0;
    margin: 0;
    color: ${colors.brandPrimary};
    font-size: 13px;
    font-weight: 500;
    line-height: 16px;
`;

export const BannerCTA = styled.div`
    margin-left: auto;
    display: flex;
    align-items: center;
    justify-content: flex-end;
`;
